module.exports = __webpack_public_path__ + "static/media/logout-purple.cab457e9.svg";